import React from "react";
import HomeNavbar from "../components/navbars/HomeNavbar";
import GoogleTranslate from "../components/translate/GoogleTranslate";

const HomeLayout = ({ children }) => {
  return (
    <>
      <HomeNavbar />
      {children}
      <GoogleTranslate/>
    </>
  );
};

export default HomeLayout;
